module.exports = __webpack_public_path__ + "img/no-data-care-icon.2581685b.svg";